<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ value }}<span v-if="total" class="plays-total"> ({{ total }})</span></span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	data: function() {

		return {
			value: '',
			total: false
		}

	},

	watch: {

		item: {
			handler: function() {

				this.updateVars()

			},
			deep: true
		}

	},

	created: function() {

		this.updateVars()

	},

	methods: {

		updateVars: function() {

			/* if (this.format.context === 'filter') {

				if (this.item.context.user || this.item.context.users) {

					this.value = (this.isUser) ? this.item.context.user.plays : this.item.context.users.totalPlays

					if (this.format.showTotal) {

						this.total = (this.isUser) ? this.item.user.plays : this.item.users.totalPlays

					}

				} else {

					this.value = '-'

				}

			} else { */

				this.value = (this.isUser) ? this.item.user.plays : this.item.users.totalPlays

			//}

		},

		onPlaysClick: function() {

			if (!this.isUser) {

				this.$pubsub.$emit('expand.open', {
					id: this.item.game.id,
					section: 'plays'
				})

			}

		}

	}

}

</script>

<style scoped>

</style>